import React, { useMemo } from 'react';
import DataGrid from '../../common/DataGrid';

/**
 * Customer grid — column definitions only.
 *
 * Before:  132 lines — full AG Grid setup, module registration,
 *          defaultColDef, container styling, action button renderer.
 * After:   ~30 lines — just the column config unique to customers,
 *          everything else handled by the shared DataGrid.
 */

const dateFormatter = (params) =>
  params.value ? new Date(params.value).toLocaleDateString() : '';

export default function CustomerGrid(props) {
  const columns = useMemo(
    () => [
      { field: 'customer_no', headerName: 'ID', maxWidth: 70, flex: 0 },
      { field: 'created_at', headerName: 'Date Added', minWidth: 130, valueFormatter: dateFormatter },
      { field: 'full_name', headerName: 'Name', minWidth: 100 },
      { field: 'street', headerName: 'Street', minWidth: 150, flex: 1 },
      { field: 'city', headerName: 'City', minWidth: 100 },
      { field: 'state', headerName: 'State', minWidth: 150 },
      { field: 'postcode', headerName: 'Postcode', maxWidth: 100 },
      { field: 'email', headerName: 'Email', minWidth: 200 },
      { field: 'phone_number', headerName: 'Phone', maxWidth: 200 },
      { field: 'abn', headerName: 'ABN', maxWidth: 100 },
    ],
    []
  );

  return (
    <DataGrid
      {...props}
      columns={columns}
      exportFileName="customer_data.csv"
    />
  );
}
